"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIdentifiers = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../../BaseAvroRecord");
class SearchIdentifiers extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.lastSearchId = null;
    }
    schema() {
        return SearchIdentifiers.schema;
    }
    subject() {
        return SearchIdentifiers.subject;
    }
}
exports.SearchIdentifiers = SearchIdentifiers;
SearchIdentifiers.subject = "search-identifiers";
SearchIdentifiers.schema = {
    "type": "record",
    "name": "SearchIdentifiers",
    "namespace": "storyblocks.search.records",
    "fields": [
        {
            "name": "searchId",
            "type": "string",
            "doc": "f.k.a. SSLID"
        },
        {
            "name": "searchPageId",
            "type": "string",
            "doc": "f.k.a. SGUID"
        },
        {
            "name": "lastSearchId",
            "type": [
                "null",
                "string"
            ],
            "doc": "Previous searchId",
            "default": null
        }
    ]
};
//# sourceMappingURL=SearchIdentifiers.js.map